import React from 'react'
import { useDispatch } from 'react-redux'

import { ActionIcon } from '../BottomHeader'
import { useAccessLevel } from '../../store/user'
import { useOpenBotId } from '../../store/app'
import { initiateBotDuplicationProcess } from '../../features/serverBots/actions/initiateBotDuplicationProcess'

export const BotDuplicateAction: React.FC = () => {
  const dispatch = useDispatch()
  const loadedBotId = useOpenBotId()
  const { edit: canEdit } = useAccessLevel()

  if (!canEdit || !loadedBotId) {
    return null
  }

  return (
    <ActionIcon
      iconName="copy"
      tooltipText="Duplicate bot"
      className="e2e-header-duplicate-bot-button"
      onClick={() => dispatch(initiateBotDuplicationProcess())}
    />
  )
}
